import Cookies from "js-cookie";

export interface ICookieConfig {
  token: string;
  personId: number;
  firstName: string;
  lastName?: string;
  language: string;
  email?: string;
  impersonationAllowed: boolean;
}

export const AUTH_SESSION_COOKIE: string = "authSession";
export const TEST_DONT_RESET_COOKIE: string = "test-dont-reset-cookie";

const setCookie = (config: ICookieConfig) => {
  const testingCookie = Cookies.get(TEST_DONT_RESET_COOKIE);

  // Remove after impersonations
  if (testingCookie) {
    Cookies.remove(TEST_DONT_RESET_COOKIE);
    return;
  }

  const cookies = Cookies.withConverter({
    write: (value) => unescape(JSON.stringify(value)),
  });

  cookies.set(AUTH_SESSION_COOKIE, config);
};

export default setCookie;
